import React, { useState } from 'react';
import Header from './components/Header';
import URLForm from './components/URLForm';
import ModeToggle from './components/ModeToggle';
import VideoPreview from './components/VideoPreview';
import useLocalStorage from './hooks/useLocalStorage';
import { Mode } from './types';
import { getWebhookConfig } from './utils/webhookService';

function App() {
  const [mode, setMode] = useLocalStorage<Mode>('youtube-sharer-mode', 'test');
  const [currentVideoId, setCurrentVideoId] = useState<string | null>(null);
  const webhookConfig = getWebhookConfig();

  return (
    <div className="min-h-screen bg-black flex flex-col">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto bg-gray-900 rounded-lg shadow-xl overflow-hidden border border-gray-800">
          <div className="p-6">
            <h2 className="text-xl font-semibold text-white text-center mb-2 neon-glow">
              Share YouTube Videos
            </h2>
            
            <p className="text-gray-400 text-center mb-6">
              Paste a YouTube URL to extract the video ID and send it to your webhook
            </p>
            
            <ModeToggle mode={mode} setMode={setMode} />
            
            <URLForm 
              mode={mode} 
              onVideoIdExtracted={setCurrentVideoId} 
            />
            
            <VideoPreview videoId={currentVideoId} />
            
            <div className="mt-8 pt-4 border-t border-gray-800">
              <h3 className="text-sm font-medium text-gray-300 mb-2">Webhook Endpoints:</h3>
              <div className="space-y-2 text-xs text-gray-400">
                <div>
                  <span className="font-medium text-blue-400">Test:</span> 
                  <code className="ml-1 bg-gray-800 px-1 py-0.5 rounded">{webhookConfig.test}</code>
                </div>
                <div>
                  <span className="font-medium text-red-400">Production:</span> 
                  <code className="ml-1 bg-gray-800 px-1 py-0.5 rounded">{webhookConfig.prod}</code>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <footer className="bg-gray-900 text-gray-400 py-4 text-center text-sm">
        <p>YouTube Sharer • {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
}

export default App;